module.exports = __webpack_public_path__ + "static/media/magic_counter.599f8d64.png";